// Generated by purs version 0.15.15
var keyup = "keyup";
var keydown = "keydown";
export {
    keydown,
    keyup
};
//# sourceMappingURL=index.js.map
